import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isExpression } from "@maplibre/maplibre-gl-style-spec";
import { useCallback } from "react";
import { Button, Group, Text, Popover, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { FormattedMessage } from "react-intl";
import { CodeEditor } from "./CodeEditor.js";
import { isArray, isEmpty } from "es-toolkit/compat";
function tryParse(value) {
    try {
        return JSON.parse(value);
    }
    catch {
        return null;
    }
}
export const ExpressionInput = ({ value, label, onChange }) => {
    const [opened, { close, toggle }] = useDisclosure(false);
    /**
     * If parsed value is valid expression, update onChange
     * If parsed value is empty string or null, update onChange with null
     */
    const handleCodeChange = useCallback((changed) => {
        const parsed = tryParse(changed);
        if (isExpression(parsed) && isArray(parsed)) {
            onChange(parsed);
            return;
        }
        if (isEmpty(changed)) {
            onChange();
            return;
        }
    }, [onChange]);
    return (_jsxs(Group, { gap: "xs", justify: "space-between", align: "center", children: [label && (_jsx(Text, { size: "xs", fw: 500, w: "18ch", children: label })), _jsxs(Popover, { opened: opened, onClose: close, position: "right-start", withArrow: true, shadow: "md", children: [_jsx(Popover.Target, { children: _jsx(Button, { size: "xs", variant: "default", flex: 1, "data-testid": "set-by-expression-button", onClick: toggle, children: _jsx(FormattedMessage, { id: "button.setByExpression", defaultMessage: "Set by expression" }) }) }), _jsx(Popover.Dropdown, { children: _jsx(Stack, { gap: "xs", w: "300px", children: _jsx(CodeEditor, { value: JSON.stringify(value, null, 2), onChange: handleCodeChange }) }) })] })] }));
};
